import { changeHeatmapDisplay } from "./heatmaps"
import {removeAQI} from "./analytics";

export const START_SLIDER = 'START_SLIDER'
export const STOP_SLIDER = 'STOP_SLIDER'
export const CHANGE_SLIDER_POSITION = 'CHANGE_SLIDER_POSITION'

export const startSlider = () => {
    return (dispatch, getStore) => {
        const { heatmaps } = getStore()
        if (heatmaps.list.length < 2) return

        const interval = setInterval(() => {
            dispatch(loopSlider())
        }, 500)

        dispatch({
            type: START_SLIDER,
            interval
        })
    }
}

export const stopSlider = () => {
    return  {
        type: STOP_SLIDER
    }
}

export const changeSliderPosition = (position) => {
    return dispatch => {
        dispatch({
            type: CHANGE_SLIDER_POSITION,
            position
        })

        dispatch(changeHeatmapDisplay(position))
    }
}

const loopSlider = () => {
    return (dispatch, getStore) => {
        const { heatmaps, slider } = getStore()

        let position = slider.position
        position++

        if (position > heatmaps.list.length - 1) position = 0
        dispatch(changeSliderPosition(position))
    }
}



// WEBPACK FOOTER //
// ./src/actions/slider.js